// #468 color-by-unit rule (locked Sep 10, Alexis): "Mix" is a BY-BOX option
// ONLY - a box filled with mixed colors. A single BUNCH is one color, so the
// by-bunch color selector never offers Mix and defaults to the variety's LEAD
// color. This is the ONE source for both decisions so every surface (Power Buyer
// chip/popover, Magazine card + quick-add, detail page) stays congruent.
import type { Variety } from "./types";

type ColorVariety = Pick<Variety, "colorTag" | "colorOptions" | "allowMixBox">;

// Mix is offered only when the buyer is buying a BOX (and the variety allows a
// mixed-color box). Never by bunch.
export function mixAllowedForUnit(
  variety: Pick<Variety, "allowMixBox">,
  // #63 box_stem: "stem" is a single-color loose-stem unit (like bunch) - Mix is
  // still box-only, so a stem never offers Mix.
  unit: "bunch" | "box" | "stem",
): boolean {
  return variety.allowMixBox === true && unit === "box";
}

// The variety's LEAD color: its colorTag when that's an orderable option, else
// the first colorOption. This is the by-bunch default (a real color, never Mix).
export function leadColor(variety: ColorVariety): string {
  const opts = variety.colorOptions ?? [];
  if (opts.length === 0) return (variety.colorTag as string) ?? "";
  if (variety.colorTag && opts.includes(variety.colorTag as string)) {
    return variety.colorTag as string;
  }
  return opts[0];
}

// Coerce a color choice to a valid one for the unit: Mix is invalid by bunch, so
// it falls back to the lead color. A real color (or box mode) passes through.
export function colorForUnit(
  variety: ColorVariety,
  color: string,
  // #63 box_stem: "stem" is single-color like bunch, so Mix coerces to lead.
  unit: "bunch" | "box" | "stem",
): string {
  if (unit !== "box" && color === "mix") return leadColor(variety);
  return color;
}
